export default __webpack_public_path__ + "static/media/11_motor_Sistemas de pago.77fb5b78.svg";